import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlCreationOptions, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

export const appGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    Observable<boolean | UrlTree> 
    | Promise<boolean | UrlTree> 
    | boolean 
    | UrlTree=> {
        const _authService = injectRequired(AuthService);
        const _router = injectRequired(Router);

        const _token = _authService.Token;
        const _returnUrl = state.url;
        const _loginPath = _authService.LOGIN_PATH;
        const _options: UrlCreationOptions = !!_returnUrl && _returnUrl !== _loginPath ? { queryParams: { returnUrl: _returnUrl }} : undefined;

    return _token && _token.length > 0
      ? true
      : _router.createUrlTree([_loginPath], _options);
  
  };
